var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddsongs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2692",
    "data-name": "Group 2692",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.863,
    height: 17.573,
    viewBox: "0 0 18.863 17.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 18.863,
    height: 17.573,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2691",
    "data-name": "Group 2691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M0,.493A.777.777,0,0,1,.8,0Q4.738.008,8.675,0A.692.692,0,0,1,9.437.75a.675.675,0,0,1-.623.637c-.055,0-.11,0-.166,0q-3.937,0-7.874,0A.746.746,0,0,1,0,.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M0,77.2a.732.732,0,0,1,.755-.495q3.983.009,7.966,0a.69.69,0,0,1,.571,1.119.7.7,0,0,1-.6.268H6.781c-1.993,0-3.986,0-5.979,0a.781.781,0,0,1-.8-.492Z",
    transform: "translate(0 -72.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M132.575,6.786q0-2.9,0-5.8a.725.725,0,0,1,.39-.716.653.653,0,0,1,.943.408,4.362,4.362,0,0,0,1.106,1.735,6.914,6.914,0,0,0,1.194.948,11.881,11.881,0,0,1,1.759,1.329,4.448,4.448,0,0,1,1.339,3.8,6.8,6.8,0,0,1-1.413,3.538.7.7,0,0,1-1.017.175.683.683,0,0,1-.083-1.011.75.75,0,0,0,.132-.8A4.778,4.778,0,0,0,134.16,7.3c-.2-.088-.2-.085-.2.127,0,2.436-.019,4.872.008,7.307a2.606,2.606,0,0,1-1.51,2.532,3.857,3.857,0,0,1-4.222-.286,2.341,2.341,0,0,1-1.051-1.912,2.236,2.236,0,0,1,.594-1.58,3.532,3.532,0,0,1,2.3-1.147,3.844,3.844,0,0,1,2.362.443c.177.1.13-.046.13-.122q0-2.54,0-5.08V6.786m-4,8.244a1.144,1.144,0,0,0,.639.943,2.544,2.544,0,0,0,1.567.351,2.345,2.345,0,0,0,1.325-.483.971.971,0,0,0,0-1.646,2.663,2.663,0,0,0-2.956-.085,1.144,1.144,0,0,0-.571.921M133.99,3.372a.264.264,0,0,0-.028.186c0,.638.007,1.276-.006,1.913a.3.3,0,0,0,.24.339,6.5,6.5,0,0,1,2.991,2.117,7.284,7.284,0,0,1,.632.968,3.2,3.2,0,0,0,.107-.617,3.024,3.024,0,0,0-.556-2.155,4.992,4.992,0,0,0-1.32-1.187c-.522-.365-1.065-.7-1.552-1.117-.171-.146-.337-.3-.508-.448",
    transform: "translate(-120.474 -0.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M50.361,130.479c0-.678,0-2.412,0-3.09a.669.669,0,0,1,.643-.744.681.681,0,0,1,.673.726c.008.777,0,2.609,0,3.386q0,.869,0,1.738a.732.732,0,0,1-.327.678.6.6,0,0,1-.653.024.621.621,0,0,1-.338-.564c0-.718,0-1.435,0-2.153",
    transform: "translate(-47.703 -119.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M2.779,178.328H.745A.669.669,0,0,1,0,177.684a.681.681,0,0,1,.726-.673c.777-.008,1.554,0,2.331,0,.579,0,2.214,0,2.794,0a.732.732,0,0,1,.678.327.6.6,0,0,1,.024.653.621.621,0,0,1-.564.338c-.718,0-2.491,0-3.208,0",
    transform: "translate(0 -167.665)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddsongs);
export default __webpack_public_path__ + "static/media/icon_addsongs.1e31acf6514296a0c6ea392c0493aa03.svg";
export { ForwardRef as ReactComponent };